import { memo } from 'react';

import { useAntiFraudMessageLogic } from './anti-fraud-message.hook';
import { ANTI_FRAUD_STRINGS } from './utils/anti-fraud-message.constants';
import type { TAntiFraudMessageConfig } from './anti-fraud-message.types';

import * as S from './anti-fraud-message.styles';

const AntiFraudMessage = memo(({ secondsOpen }: TAntiFraudMessageConfig) => {
	const { show, handleCloseAntiFraud } = useAntiFraudMessageLogic(secondsOpen);

	if (!show) return null;

	return (
		<S.AntiFraudMessage data-testid="anti-fraud-message" data-qa="anti-fraud-message">
			<S.AntiFraud data-testid="anti-fraud" data-qa="anti-fraud" className="anti-fraud-wrapper">
				<S.TextWrapper>
					<svg aria-label="warning" className="warningIcon" width={20} height={20} viewBox="3 3 26 26" />
					<S.Text>
						<strong>{ANTI_FRAUD_STRINGS.TEXT_BOLD}</strong> {ANTI_FRAUD_STRINGS.TEXT_SUFFIX}
					</S.Text>
				</S.TextWrapper>

				<S.Button type="button" data-qa="anti-fraud-close-button" secondsOpen={secondsOpen} onClick={handleCloseAntiFraud}>
					<svg aria-label="circle" className="circleIcon" width={20} height={20} />
					<svg aria-label="x" className="closeIcon" width={20} height={20} viewBox="0 0 20 20" />
				</S.Button>
			</S.AntiFraud>
		</S.AntiFraudMessage>
	);
});

AntiFraudMessage.displayName = 'AntiFraudMessage';
export { AntiFraudMessage };
